import { createFileRoute, redirect } from '@tanstack/react-router';

/** /settings opens Credits, the first item of the sub-nav (design st-app.jsx default view). */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings/credits', search, replace: true });
  },
});
